import React from 'react';
import './App.css';
import Grafo from './components/Grafo';
import Navigation from './components/Navigation';

function App() {
  return (
    <div className="App">
      <Grafo></Grafo>
    </div>
  );
}

export default App;
